import { extend, localize, validate } from 'vee-validate';
// eslint-disable-next-line camelcase
import { required, min, min_value, max_value, max, email, digits, numeric } from 'vee-validate/dist/rules';
import isIsraeliIdValid from 'israeli-id-validator';
import dayjs from 'dayjs';

function isNameCharacter(str) {
  return (/^[\u05D0-\u05EA\u05F3 -]+$/).test(str); // Hebrew letter, apostrophe, space or hyphen only
}

function freeTextAddress(str) {
  return (/^[\u05D0-\u05EA\u05F3 \d-]+$/).test(str); // Hebrew letter, digits, space or hyphen only
}

function notUnderAge(dateString) {
  const parsedDate = dayjs(dateString, 'DD-MM-YYYY');
  const eighteenYearsAgo = dayjs().subtract(18, 'year');
  return parsedDate.isBefore(eighteenYearsAgo);
}

function notFuture(dateString) {
  const parsedDate = dayjs(dateString, 'DD-MM-YYYY');
  const tomorrow = dayjs().add(1, 'day');
  return parsedDate.isBefore(tomorrow);
}

function dateExists(dateString) {
  return dayjs(dateString, 'DD-MM-YYYY', true).isValid();
}

const socialIdValidation = {
  message(field, args) {
    return args[0];
  },
  validate(value) {
    return validate(value, 'required');
  },
  computesRequired: true,
};

const maxDepositSum = {
  validate(value, args) {
    const calculatedMax = args.max;
    return validate(value, `max_value:${calculatedMax}`);
  },
  params: ['max'],
};

const minDeposit = {
  validate(value, args) {
    return value === 0 || validate(value, `min_value:${args.min}`);
  },
  params: ['min'],
};

extend('required', required);
extend('min', min);
extend('max', max);
extend('max_value', max_value);
extend('min_value', min_value);
extend('email', email);
extend('digits', digits);
extend('numeric', numeric);
extend('socialId', isIsraeliIdValid);
extend('nameCharacters', isNameCharacter);
extend('freeTextAddress', freeTextAddress);
extend('notUnderAge', notUnderAge);
extend('notFuture', notFuture);
extend('dateExists', dateExists);
extend('socialIdValidation', socialIdValidation);
extend('maxDeposit', maxDepositSum);
extend('minDeposit', minDeposit);

localize({
  he: {
    messages: {
      required: 'שדה חובה',
      min: 'יש להכניס לפחות {length} אותיות',
      max: 'יש להכניס עד {length} תווים',
      min_value: 'נא להכניס ערך מעל ל-{min}',
      max_value: 'נא להכניס ערך מתחת ל-{max}',
      email: 'כתובת המייל לא תקינה',
      digits: '{length} ספרות בלבד',
      numeric: 'ספרות בלבד',
      socialId: 'מספר ת.ז. לא תקין',
      nameCharacters: 'אותיות בעברית, מקף ורווח בלבד',
      freeTextAddress: 'אותיות בעברית, ספרות, מקף ורווח בלבד',
      notUnderAge: 'אפשר לפתוח קופה מגיל 18 ומעלה',
      dateExists: 'התאריך לא תקין',
      notFuture: 'אופס…בחרת בתאריך עתידי',
      maxDeposit: 'אפשר להפקיד בשנה סכום כולל של עד 81,711 ₪',
      minDeposit: 'אפשר להפקיד מ-{min} ₪ ומעלה',
    },
  },
});

localize('he');
